import _ from 'lodash';
import moment from 'moment';

const toQueryStrings = params => {
  return Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] == null ? '' : params[key])}`)
    .join('&');
};

const validateDateTime = async value => {
  if (_.isEmpty(value)) {
    return true;
  }

  return moment.parseZone(value).isValid();
};

const showBrowserAlert = message => {
  const fn = window.alert;
  fn(message);
};

export default {
  toQueryStrings,
  validateDateTime,
  showBrowserAlert
};

export { showBrowserAlert };
